export const APP_VERSION = 'v2026.11.03';
export const BUILD_TIME = '17:52';
export const FULL_VERSION = 'v2026.11.03 · 17:52';
